import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ErrorBoundary } from "./routes/routes";

// Mobile WebView auth injection — reads token from URL params set by native app
try {
  const _searchParams = new URLSearchParams(window.location.search);
  const _appToken = _searchParams.get('app_access_token');
  const _appType = _searchParams.get('app_type');
  if (_appToken) {
    localStorage.setItem('access_token', _appToken);
    if (_appType) localStorage.setItem('type', _appType.trim().toLowerCase());
  }
} catch (err) {
  // storage blocked (private browsing, locked-down webview, cookies disabled, etc.)
  console.error("Mobile auth injection failed, storage unavailable", err);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </ErrorBoundary>
  // </React.StrictMode>
);
reportWebVitals();
